import { render, staticRenderFns } from "./project-add-or-update.vue?vue&type=template&id=5413b93e&scoped=true"
import script from "./project-add-or-update.vue?vue&type=script&lang=js"
export * from "./project-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./project-add-or-update.vue?vue&type=style&index=0&id=5413b93e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5413b93e",
  null
  
)

export default component.exports